import {
  duplicateLinePreviewLabel,
  type DuplicateRecipeDraft,
} from "@/lib/manufacturing/duplicateRecipeDraft";

export function ManufacturingModelsDuplicatePreview({
  draft,
}: {
  draft: DuplicateRecipeDraft | null;
}) {
  if (!draft) return null;
  return (
    <div className="rounded-lg border border-indigo-200 bg-indigo-50/60 px-3 py-2 text-xs text-indigo-950 dark:border-indigo-800 dark:bg-indigo-950/30 dark:text-indigo-100">
      <div className="font-semibold">
        Duplicating from {draft.sourceCode} · {draft.sourceName}
      </div>
      <p className="mt-1 text-indigo-900/90 dark:text-indigo-100/90">
        Kind, tags, notes, and {draft.lines.length} BOM line
        {draft.lines.length === 1 ? "" : "s"} will copy when you save. Code and name are
        prefilled from the source — change both before saving.
      </p>
      {draft.lines.length > 0 ? (
        <ul className="mt-2 max-h-28 space-y-0.5 overflow-y-auto text-[11px]">
          {draft.lines.slice(0, 8).map((ln, i) => (
            <li
              key={`${ln.line_kind}-${ln.material_id}-${ln.component_recipe_id}-${ln.material_use_id}-${i}`}
            >
              {duplicateLinePreviewLabel(ln)}
              {" · qty "}
              {ln.quantity}
            </li>
          ))}
          {draft.lines.length > 8 ? (
            <li className="text-indigo-800/80 dark:text-indigo-200/80">
              + {draft.lines.length - 8} more line(s)
            </li>
          ) : null}
        </ul>
      ) : null}
    </div>
  );
}
